import './SimpleDatesRange.css';

import React from 'react';
import { generateClassName, toLocaleDateTime } from '../../../b2b-common/helpers';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const SimpleDatesRange = ({ startDate, endDate, className = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    return (
        <div className={generateClassName('simple-dates-range','',className)}>
            {t('From ')}
            <div className='simple-dates-range-start'>
                <div className='simple-dates-range-value'>
                    {toLocaleDateTime(startDate)}
                </div>
            </div>
            <div className='simple-dates-range-separator'>
            {t(' to ')}
            </div>
            <div className='simple-dates-range-end'>
                <div className='simple-dates-range-value'>
                    {toLocaleDateTime(endDate)}
                </div>
            </div>
        </div>
    );
}

export default SimpleDatesRange;